<template>
  <span
    class="sortable-header"
    :class="{ 'sortable-header--active': isActive }"
    role="button"
    tabindex="0"
    :aria-sort="ariaSort"
    :data-cy="dataCy"
    @click="onActivate"
    @keydown.enter.prevent="onActivate"
    @keydown.space.prevent="onActivate"
  >
    <span class="sortable-header__label">{{ label }}</span>
    <font-awesome-icon class="sortable-header__icon" :icon="icon" />
  </span>
</template>

<script>
const ASC = 'ASC';
const DESC = 'DESC';

export default {
  name: 'EzSortableHeader',
  props: {
    label: {
      type: String,
      default: '',
    },
    sortKey: {
      type: String,
      required: true,
    },
    activeKey: {
      type: String,
      default: null,
    },
    direction: {
      type: String,
      default: DESC,
      validator: value => [ASC, DESC].includes(value),
    },
    mode: {
      type: String,
      default: 'both',
      validator: value => ['asc', 'desc', 'both'].includes(value),
    },
    dataCy: {
      type: String,
      default: null,
    },
  },
  computed: {
    isActive() {
      return this.sortKey === this.activeKey;
    },
    initialDirection() {
      return this.mode === 'asc' ? ASC : DESC;
    },
    icon() {
      if (this.mode === 'asc') return 'angle-up';
      if (this.mode === 'desc') return 'angle-down';
      const dir = this.isActive ? this.direction : DESC;
      return dir === ASC ? 'angle-up' : 'angle-down';
    },
    ariaSort() {
      if (!this.isActive) return 'none';
      return this.direction === ASC ? 'ascending' : 'descending';
    },
  },
  methods: {
    onActivate() {
      let direction;
      if (!this.isActive) {
        direction = this.initialDirection;
      } else if (this.mode === 'both') {
        direction = this.direction === ASC ? DESC : ASC;
      } else {
        direction = this.mode === 'asc' ? ASC : DESC;
      }
      this.$emit('sort', { sortBy: this.sortKey, direction });
    },
  },
};
</script>

<style scoped lang="scss">
.sortable-header {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  user-select: none;
  outline: none;

  &__icon {
    font-size: 16px;
    opacity: 0.4;
    transition: opacity 0.15s ease-in-out;
  }

  &:hover &__icon {
    opacity: 0.7;
  }

  &--active {
    .sortable-header__icon {
      color: $color-primary-blue;
      opacity: 1;
    }
  }
}
</style>
